// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { okInsuranceComponents } = require('ok-insurance');
const { InsuranceRequestRelatedWizard } = okInsuranceComponents.insuranceRequestRelatedWizard;
const { InsuranceRequestRelatedRNCWizard } = okInsuranceComponents.insuranceRequestRelatedRNCWizard;

// @ constants
const { okInsuranceConstants } = require('ok-insurance');
const ROUTES = okInsuranceConstants.insuranceRequestRoutes;

const MortgageInsurancesRelatedView = ({ immGlobalPosition }) => {
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: ROUTES.MORTGAGE_LANDING
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: ROUTES.MORTGAGE_PANEL
        },
        {
            text: formatText('insuranceRelatedRequest-title')
        }
    ];
    return (
        <div className="mortgage-request-insurances-related-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('insuranceRelatedRequest-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12">
                            {isClientWithoutAccounts
                                ? <InsuranceRequestRelatedRNCWizard />
                                : <InsuranceRequestRelatedWizard />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MortgageInsurancesRelatedView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageInsurancesRelatedView);
